import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareModule } from '../_share/share.module';
import { ChemistshopeRoutingModule } from './chemistshop-routing.module';

import { ChemistshopLayoutComponent } from './chemistshop-layout/chemistshop-layout.component';
import { ChemistshopDashboardComponent } from './chemistshop-dashboard/chemistshop-dashboard.component';
import { EbayOrdersComponent } from './ebay-orders/ebay-orders.component';
import { EbayOrderDetailsComponent, ViewQADialog } from './ebay-order-details/ebay-order-details.component';
import { GrouponOrdersComponent } from './groupon-orders/groupon-orders.component';
import { GrouponOrderDetailsComponent, ViewGrouponQADialog } from './groupon-order-details/groupon-order-details.component';
import { OnbuyOrdersComponent } from './onbuy-orders/onbuy-orders.component';
import { OnbuyOrderDetailsComponent, ViewOnbuyQADialog } from './onbuy-order-details/onbuy-order-details.component';
import { ShipstationOrdersComponent } from './shipstation-orders/shipstation-orders.component';
import { ShipstationOrdersDetailsComponent } from './shipstation-orders-details/shipstation-orders-details.component';

@NgModule({
  declarations: [
    EbayOrdersComponent, 
    ChemistshopLayoutComponent, 
    ChemistshopDashboardComponent, 
    EbayOrderDetailsComponent, ViewQADialog, 
    GrouponOrdersComponent, GrouponOrderDetailsComponent, ViewGrouponQADialog, 
    OnbuyOrdersComponent, OnbuyOrderDetailsComponent, ViewOnbuyQADialog, ShipstationOrdersComponent, ShipstationOrdersDetailsComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule, FormsModule,
    ChemistshopeRoutingModule,
    ShareModule,
  ],
  entryComponents:[
    ViewQADialog, ViewGrouponQADialog, ViewOnbuyQADialog
  ]
})
export class ChemistshopModule { }
